/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import TypeMate from 'typemate';

import BackgroundImage from './modules/background-image';
import Carousel from './modules/carousel';
import LanguageSwitch from './modules/language-switch';
import LazyLoadImages from './modules/lazy-load-images';
import Menu from './modules/menu';
import Parallax from './modules/parallax';
import SideNav from './modules/side-nav';
import Slider from './modules/slider';
import SliderSubheadingCarousel from './modules/slider-subheading-carousel';
import SliderSwiper from './modules/slider-swiper';

import barba from '@barba/core';
import barbaCss from '@barba/css';
import 'hammerjs';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.moduleInstances = [];
        this.prevModuleInstances = [];
        this.bindAll();
        this.barbaInit();
        this.menuInstance;
        this.lazyLoadImages = new LazyLoadImages;
        this.lazyLoadImages.init();
        this.menuInstance.setActivePage();
    },

    bindAll() {
        this.bind('permamodule');
        this.bind('module');
    },

    bind(type) {
        this.prevModuleInstances = this.moduleInstances;
        this.moduleInstances = [];

        let modulePlaceHolders = [];

        // Load any items that need modules
        // if its a module we could have two barba view containers still in the dom
        // so only bind the last container (i.e. the new view).
        if(type === 'module') {
            let barbaContainers = document.querySelectorAll('[data-barba="container"]');
            let barbaContainer =  barbaContainers[barbaContainers.length - 1];

            modulePlaceHolders = [...barbaContainer.querySelectorAll(`[data-${type}]`)];
        } else {
            modulePlaceHolders = [...document.querySelectorAll(`[data-${type}]`)];
        }

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute(`data-${type}`);

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'slider':

                        let sliderInstance = new Slider(item);

                        sliderInstance.init();
                        this.pushModuleInstance(sliderInstance, type);

                        break;

                    case 'menu':

                        let menuInstance = new Menu(item);

                        menuInstance.init();
                        this.pushModuleInstance(menuInstance, type);
                        this.menuInstance = menuInstance;

                        break;

                    case 'side-nav':

                        let sideNavModule = new SideNav(item);

                        sideNavModule.init();
                        this.pushModuleInstance(sideNavModule, type);

                        break;

                    case 'language-switch':

                        let languageSwitchModule = new LanguageSwitch(item);

                        languageSwitchModule.init();
                        this.pushModuleInstance(languageSwitchModule, type);

                        break;

                    case 'slider-subheading-carousel':

                        let sliderSubheadingCarouselModule = new SliderSubheadingCarousel(item);

                        sliderSubheadingCarouselModule.init();
                        this.pushModuleInstance(sliderSubheadingCarouselModule, type);

                        break;

                    case 'slider-swiper':

                        let sliderSwiperModule = new SliderSwiper(item);

                        sliderSwiperModule.init();
                        this.pushModuleInstance(sliderSwiperModule, type);

                        break;

                    case 'parallax':

                        let parallaxModule = new Parallax(item);

                        parallaxModule.init();
                        this.pushModuleInstance(parallaxModule, type);

                        break;

                    case 'carousel':

                        let carouselInstance = new Carousel(item);

                        carouselInstance.init();
                        this.pushModuleInstance(carouselModule, type);

                        break;
                }
            });
        });
    },

    pushModuleInstance(instance, type) {
        if(type === 'module') {
            this.moduleInstances.push(instance);
        }
    },

    unbind() {
        this.prevModuleInstances.forEach(moduleInstance => {
            if(moduleInstance.destroy) {
                moduleInstance.destroy();
                moduleInstance = null;
            }
        });

        this.prevModuleInstances = [];
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate();
        // typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    },

    fadeOut(data) {
        console.log('fadeOut', data);
    },

    barbaInit() {
        let self = this;

        barba.use(barbaCss);

        barba.hooks.enter((data) => {
            self.menuInstance.closeMenu();
            window.scrollTo(0,0); // scroll to top of next page whilst transition is happening.
            this.bind('module'); // bind js modules for new view
            // this.bind('permamodule'); // bind js permamodules for new view
            this.lazyLoadImages.init();
            this.menuInstance.setActivePage();
        });

        barba.hooks.afterEnter((data) => {
            this.unbind(); // unbind js modules from old view

            if (location.hash) {
                $('html, body').animate({
                    scrollTop: $(location.hash).offset().top
                }, 100);
            }
        });

        barba.init({
            timeout: 5000,
            requestError: (trigger, action, url, response) => {
                // go to a custom 404 page if the user click on a link that return a 404 response status
                if (action === 'click' && response.status && response.status === 404) {
                  barba.go('/404');
                }

                // prevent Barba from redirecting the user to the requested URL
                return false;
            },
            transitions: [{
                name: 'with-cover',
                to: { namespace: ['with-cover'] },
                async leave() {},
                enter() {},
            },
            {
              name: 'fade',
              sync:true,
              from: {
                custom: ({trigger}) => {
                    return trigger.hasAttribute("data-trigger");
                }
              },
              leave(data) {},
              beforeEnter(data) {

                data.current.container.classList.add('fo-transition');
                data.current.container.classList.add('fo');

              },
              enter() {}
            }]
        });
    }
};

// Launch
app.init();
